import { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import ThemeProvider from 'react-bootstrap/ThemeProvider';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import GlobalStyle from '../../theme/GlobalStyle';
import { Form, Col, Row, Button, InputGroup, InputGroupProps} from 'react-bootstrap';


import theme from '../../theme';
import Style from './style';

import getMaximumMonthlyIP from '../../services/getMaxMonthlyIP';


type FormData = {
    earnings: number;
  }
  
  const App = () => {

    const [textOne, setTextOne] = useState<string>('');
    const [textTwo, setTextTwo] = useState<string>('');

    useEffect(() => {
        const subdomain = window.location.hostname.split('.')[0]; 

        const textValueOne = subdomain === 'adviser' ? 'your clients' : 'you';
        setTextOne(textValueOne);

        const textValueTwo = subdomain === 'adviser' ? 'Please enter annual earnings to calculate maximum monthly Income Protection.' : `Please enter your annual earnings to calculate the maximum monthly Income Protection you can have.
        \n \n This is your personal taxable earnings before you pay any income tax, minus any expenses which are allowable against income tax. `;
        setTextTwo(textValueTwo);
    }, []);

      const methods = useForm<FormData>();
      const { handleSubmit, control } = methods;
      const [result, setResult] = useState<number | null>(null);
  
      const resultOnSubmit = (data: FormData) => {

          const annualEarnings = data.earnings.toString();
          const maxMonthlyIP = getMaximumMonthlyIP(Number(annualEarnings));

          if (maxMonthlyIP) {
            setResult(maxMonthlyIP);
          }

      };
      return (
          <ThemeProvider breakpoints={['lg', 'md', 'sm', 'xs']} minBreakpoint="xs">
              <StyledComponentsThemeProvider theme={theme}>
                  <GlobalStyle />
                  <Style>
                    <div className='introContent'>
                        <h1 className='mb-4'>
                            Quick Calculator
                        </h1>
                        <p>
                        Work out the total amount of Income Protection available to {textOne}.
                        </p>
                    </div>
                      <Form className='mb-4' onSubmit={handleSubmit(resultOnSubmit)}>
                          <Form.Group as={Row} className="mt-2 mb-2" controlId="formSalary">
                              <Form.Label column sm={5}>Annual earnings before tax</Form.Label>
                              <Col sm={4}>
                              <Controller
                                    control={control}
                                    name="earnings"
                                    rules={{ required: 'Your monthly outgoings are required.' }}
                                    render={({ field: { onChange, value } }) => (
                                        <NumericFormat
                                            customInput={Form.Control}
                                            thousandSeparator={true}
                                            prefix={'£ '}
                                            placeholder="£"
                                            onValueChange={v => onChange(v.value)}
                                            defaultValue={value}
                                        />
                                    )}
                                />
                                  
                              </Col>
                              <Col sm={3}>
                                  <Button className={`gold-btn`} type="submit">
                                      <div className="button-content">
                                          Calculate
                                      </div>
                                  </Button>
  
                              </Col>
                          </Form.Group>
                      </Form>
                      
                      <div className='resultBox'>
                          <h3>
                          Maximum monthly Income Protection available
                          </h3>
                          {result !== null ? (
                              <>
                                  <p className={result >= 20833 ? 'resultFigure red' : 'resultFigure'}> {'£' + new Intl.NumberFormat('en',
                                    {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    }).format(result)
                            } </p>
                            {result >= 20833 && (
                                <p className='resultRedParagraph'>
                                    Income Protection is capped at our maximum available, which is £20,833 a month. For more information please see our <a href='https://content.guardian1821.co.uk/literature/policy-terms-conditions.pdf'>terms and conditions.</a>
                                </p>
                            )}
                                  <p className='resultSuffix'>This total amount is worked out as: 65% of annual earnings up to £60,000, 50% annual earnings
                                      between £60,000-£100,000 and 45% of annual earnings over £100,000.</p>
                              </>
                          ) : (
                              <p className='resultSuffix'>{textTwo}</p>
                          )}
                      </div>
                  </Style>
              </StyledComponentsThemeProvider>
          </ThemeProvider>
      );
  };
  
  export default App;